(function () {
  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function initSlider(el) {
    if (el.dataset.priceSliderInitialized) return;
    el.dataset.priceSliderInitialized = 'true';

    var rangeMin = parseFloat(el.dataset.rangeMin) || 0;
    var rangeMax = parseFloat(el.dataset.rangeMax) || 0;
    if (rangeMax <= rangeMin) return;

    var minHandle = el.querySelector('[data-price-slider-handle="min"]');
    var maxHandle = el.querySelector('[data-price-slider-handle="max"]');
    var rangeFill = el.querySelector('[data-price-slider-range]');
    if (!minHandle || !maxHandle || !rangeFill) return;

    var minInput = document.getElementById(minHandle.dataset.target);
    var maxInput = document.getElementById(maxHandle.dataset.target);

    var currentMin = clamp(parseFloat(el.dataset.currentMin), rangeMin, rangeMax);
    var currentMax = clamp(parseFloat(el.dataset.currentMax), rangeMin, rangeMax);
    if (isNaN(currentMin)) currentMin = rangeMin;
    if (isNaN(currentMax)) currentMax = rangeMax;

    function valueToPercent(value) {
      return ((value - rangeMin) / (rangeMax - rangeMin)) * 100;
    }

    function percentToValue(percent) {
      return rangeMin + (percent / 100) * (rangeMax - rangeMin);
    }

    function render() {
      var minPercent = valueToPercent(currentMin);
      var maxPercent = valueToPercent(currentMax);

      minHandle.style.left = minPercent + '%';
      maxHandle.style.left = maxPercent + '%';
      minHandle.setAttribute('aria-valuenow', Math.round(currentMin));
      maxHandle.setAttribute('aria-valuenow', Math.round(currentMax));

      rangeFill.style.left = minPercent + '%';
      rangeFill.style.width = (maxPercent - minPercent) + '%';
    }

    function commit(dispatchChange) {
      if (minInput) {
        minInput.value = Math.round(currentMin);
        if (dispatchChange) {
          minInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      if (maxInput) {
        maxInput.value = Math.round(currentMax);
        if (dispatchChange) {
          maxInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    function valueFromClientX(clientX) {
      var rect = el.getBoundingClientRect();
      var percent = ((clientX - rect.left) / rect.width) * 100;
      percent = clamp(percent, 0, 100);
      return percentToValue(percent);
    }

    function startDrag(handleType, pointerId, target) {
      target.setPointerCapture(pointerId);

      function onMove(event) {
        var value = valueFromClientX(event.clientX);

        if (handleType === 'min') {
          currentMin = clamp(value, rangeMin, currentMax);
        } else {
          currentMax = clamp(value, currentMin, rangeMax);
        }

        render();
      }

      function onUp() {
        target.removeEventListener('pointermove', onMove);
        target.removeEventListener('pointerup', onUp);
        target.removeEventListener('pointercancel', onUp);
        commit(true);
      }

      target.addEventListener('pointermove', onMove);
      target.addEventListener('pointerup', onUp);
      target.addEventListener('pointercancel', onUp);
    }

    minHandle.addEventListener('pointerdown', function (event) {
      event.preventDefault();
      startDrag('min', event.pointerId, minHandle);
    });

    maxHandle.addEventListener('pointerdown', function (event) {
      event.preventDefault();
      startDrag('max', event.pointerId, maxHandle);
    });

    function stepValue(handleType, direction) {
      var step = Math.max(1, Math.round((rangeMax - rangeMin) / 100));

      if (handleType === 'min') {
        currentMin = clamp(currentMin + direction * step, rangeMin, currentMax);
      } else {
        currentMax = clamp(currentMax + direction * step, currentMin, rangeMax);
      }

      render();
      commit(true);
    }

    [
      [minHandle, 'min'],
      [maxHandle, 'max']
    ].forEach(function (pair) {
      var handle = pair[0];
      var handleType = pair[1];

      handle.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
          event.preventDefault();
          stepValue(handleType, -1);
        } else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
          event.preventDefault();
          stepValue(handleType, 1);
        } else if (event.key === 'Home') {
          event.preventDefault();
          if (handleType === 'min') {
            currentMin = rangeMin;
          } else {
            currentMax = currentMin;
          }
          render();
          commit(true);
        } else if (event.key === 'End') {
          event.preventDefault();
          if (handleType === 'min') {
            currentMin = currentMax;
          } else {
            currentMax = rangeMax;
          }
          render();
          commit(true);
        }
      });
    });

    function syncFromInputs() {
      if (minInput) {
        var minValue = parseFloat(minInput.value);
        if (!isNaN(minValue)) currentMin = clamp(minValue, rangeMin, currentMax);
      }
      if (maxInput) {
        var maxValue = parseFloat(maxInput.value);
        if (!isNaN(maxValue)) currentMax = clamp(maxValue, currentMin, rangeMax);
      }
      render();
    }

    if (minInput) minInput.addEventListener('input', syncFromInputs);
    if (maxInput) maxInput.addEventListener('input', syncFromInputs);

    render();
  }

  function init() {
    document.querySelectorAll('[data-price-slider]').forEach(initSlider);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
